<template>
    <div class="form-group mb-0">
        <label v-if="label" :for="id" :class="hideLabel ? 'sr-only' : 'field-label'">{{ label }}</label>

        <div v-if="options">
            <admin-select
                :id="id"
                :value="value"
                :options="options"
                :class="controlClasses"
                :disabled="disabled"
                :required="required"
                @input="$emit('input', $event)"
            />
        </div>
        <textarea
            v-else-if="type === 'textarea'"
            :id="id"
            :value="value"
            :rows="rows"
            :placeholder="placeholder"
            :class="controlClasses"
            :disabled="disabled"
            :required="required"
            @input="$emit('input', $event.target.value)"
        ></textarea>
        <input
            v-else
            :id="id"
            :value="value"
            :type="type"
            :placeholder="placeholder"
            :class="controlClasses"
            :disabled="disabled"
            :required="required"
            @input="$emit('input', $event.target.value)"
        />

        <small v-if="help" class="form-text text-pip-gray mt-1">{{ help }}</small>
    </div>
</template>

<script>
import AdminSelect from "./SelectField";

export default {
    name: "AdminFormField",
    components: { AdminSelect },
    props: {
        id: { type: String, required: true },
        label: { type: String, default: "" },
        value: { default: "" },
        type: { type: String, default: "text" },
        options: { type: Array, default: null },
        rows: { type: Number, default: 4 },
        placeholder: { type: String, default: "" },
        help: { type: String, default: "" },
        hideLabel: { type: Boolean, default: false },
        compact: { type: Boolean, default: true },
        variant: { type: String, default: "default" },
        monospace: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
    },
    computed: {
        controlClasses() {
            return [
                "form-control",
                { "form-control-sm": this.compact, "title-control": this.variant === "title", "font-monospace": this.monospace },
            ];
        },
    },
};
</script>

<style scoped lang="scss">
.field-label {
    display: block;
    margin-bottom: 0.35rem;
    padding: 0;
    color: var(--color-pip-gray);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-bold);
    letter-spacing: var(--tracking-wider);
    text-transform: uppercase;
}

.title-control {
    height: auto;
    padding: 0.55rem 0.7rem;
    font-size: var(--font-size-xl);
    line-height: var(--line-height-tight);
}

.font-monospace {
    font-family: SFMono-Regular, Consolas, "Liberation Mono", monospace;
    font-size: 0.8rem;
}
</style>
